import { render, staticRenderFns } from "./leaflet-map-polygon.vue?vue&type=template&id=2a06a2fc"
import script from "./leaflet-map-polygon.vue?vue&type=script&lang=ts"
export * from "./leaflet-map-polygon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/apps/front/flightpath-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a06a2fc')) {
      api.createRecord('2a06a2fc', component.options)
    } else {
      api.reload('2a06a2fc', component.options)
    }
    module.hot.accept("./leaflet-map-polygon.vue?vue&type=template&id=2a06a2fc", function () {
      api.rerender('2a06a2fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flightpath-components/lib-components/leaflet-map-polygon.vue"
export default component.exports